import jwtAuthKioskAxios from "../auth/jwtAuthKiosk";
import { setBackendDomain } from "./management";

export const createDSOKPromotion = async (promotion) => {
  setBackendDomain(jwtAuthKioskAxios);
  try {
    const data = await jwtAuthKioskAxios.post(`/dsok/promotions/`, promotion);
    return data?.data?.promotion;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const getDSOKPromotions = async () => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.get(`/dsok/promotions`);
  return data?.data?.promotions;
};

export const deleteDSOKPromotion = async (promotionId) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.delete(
    `/dsok/promotions/${promotionId}`
  );
  return data?.data?.code;
};

export const getDSOKPromotion = async (promotionId) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.get(`/dsok/promotions/${promotionId}`);
  return data?.data?.promotion;
};

export const updateDSOKPromotion = async (promotionId, promotion) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.put(
    `/dsok/promotions/${promotionId}`,
    promotion
  );
  return data?.data?.code;
};
